import type { FaireProductEntity } from "../../entity_types/product";

export const p_x9x2bqn3v6: FaireProductEntity = {
  token: "p_x9x2bqn3v6",
  type: "product",
  name: "Pasta Paper Clips - Ravioli + Farfalle",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/f64a18c1c51cebd39972421e8f9f5dcb29319d3e62450e9e962cc7dda7a8aa10.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/556988fe073ff4847c5004f9d93d6d350c3758094fc36e88090fb616bb3449ad.jpeg",
    "https://cdn.faire.com/fastly/1b1176f8195ca28856dfe1d88e9c392ed844a1c87bd6f26a23b98df3722fc366.jpeg"
  ],
  priceDollars: 5,
  description: "Set of 6 unique and versatile gold clips that can be used as paperclips, page holders, or bookmarks.\n\nSecure your top-secret documents, bookmark your essentials, and use them for as long as you'd like! Each pack of 6 comes in recycled paper packaging.\n\n𝐆𝐨𝐨𝐝 𝐭𝐨 𝐤𝐧𝐨𝐰:\n\n• Each set of paperclips is secured in a paper sleeve with insert/backing.\n• Packaging measures 3\" x 4\" x .25\"\n• Paper clips measure 30mm x 30mm\n• 6 gold reusable paperclips per pack (3 ravioli, 3 farfalle)",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:34:02.663Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
